let _correlationId = '';

export const getCorrelationId = () => _correlationId;

export function initCorrelationId(id: string) {
    _correlationId = id;
}
